import api from "./config/axiosConfig";
import Material from "../models/furniture/Material";
import Shape from "../models/furniture/Shape";
import Element from "../models/furniture/Element";

const ELEMENTS_URL = "/viewer/elements_by_layout/";
const DESIGN_STEP_OPTIONS_URL = "/designs/navigate-options/";
const DESIGN_PREVIEW_URL = "/designs/select-option/";

export interface DesignStepInfo {
  step_type: "SH" | "MT";
  number_of_shapes?: number;
  shape_number?: number;
  material_number?: number | null;
}

export interface DesignSelectionApiRequestBody {
  design_composition?: string;
  layout: string;
  step_info?: DesignStepInfo;
}

export const getElementsByLayout = async (
  layout_body_id: number,
  layout_size_id: number
): Promise<Element[]> => {
  const response = await api.get(
    `${ELEMENTS_URL}${layout_body_id}/${layout_size_id}/`
  );
  return response.data.map((element: Partial<Element>) => new Element(element));
};

export const getDesignPreview = async ({
  layout,
  design_composition,
  step_info,
}: DesignSelectionApiRequestBody): Promise<{
  image: string;
  image_url: string | null;
  design_composition: string;
  shapes: Record<string, Shape> | null;
  materials: Record<string, Material> | null;
}> => {
  const response = await api.post(DESIGN_PREVIEW_URL, {
    layout,
    design_composition,
    step_info,
  });

  return response.data;
};

export const getDesignStepOptions = async ({
  layout,
  design_composition,
  step_info,
}: DesignSelectionApiRequestBody): Promise<{
  shapes?: Shape[];
  materials?: Material[];
}> => {
  const response = await api.post(DESIGN_STEP_OPTIONS_URL, {
    layout,
    design_composition,
    step_info,
  });

  return response.data;
};
